<!-- <ngx-ui-loader ngxUiLoaderBlurred  ></ngx-ui-loader> -->

<ngx-ui-loader   ></ngx-ui-loader>
<app-maintenance-banner></app-maintenance-banner>
<router-outlet></router-outlet>